import { onMessageListener } from 'Components/Firebase';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const NotificationToast = () => {
    const [notification, setNotification] = useState({
        title: '',
        body: '',
        link: ''
    });
    const notify = () => toast(<ToastData />);
    useEffect(() => {
        if (notification?.title) {
            notify();
        }
    }, [notification]);
    const ToastData = () => (
        <a href={notification?.link} className="custom-notification">
            <div className="title">{notification?.title}</div>
            <div className="description">{notification?.body}</div>
        </a>
    );
    onMessageListener().then((payload) => {
        setNotification({
            title: payload?.notification?.title,
            body: payload?.notification?.body,
            link: payload?.fcmOptions?.link
        });
    });
    return <ToastContainer position="top-right" hideProgressBar closeOnClick={false} />;
};
export default NotificationToast;
